import t from "./td-longtail-vue-components270.js";
/* empty css                              */
import s from "./td-longtail-vue-components98.js";
var i = function() {
  var e = this, n = e._self._c, r = e._self._setupProxy;
  return n("div", { staticClass: "gdpr-permission-layer" }, [n(r.NoAccessIcon, { staticClass: "gdpr-permission-layer__icon" }), n(r.Paragraph, { staticClass: "gdpr-permission-layer__main_copy text--bold", attrs: { "no-margin": "", text: "Leider können wir diesen Inhalt aufgrund Ihrer Cookie-Einstellungen nicht anzeigen." } }), n(r.Paragraph, { staticClass: "gdpr-permission-layer__sub_copy", attrs: { "no-margin": "" } }, [e._v(" Bitte in den "), n(r.LinkButton, { staticClass: "gdpr-permission-layer__link", attrs: { tag: "button", "text-neutral": "" }, on: { click: r.onSettingsReset } }, [e._v(" Einstellungen ")]), e._v(' "Dienste von anderen Unternehmen" aktivieren ')], 1)], 1);
}, a = [], o = /* @__PURE__ */ s(
  t,
  i,
  a,
  !1,
  null,
  "a840f9f4"
);
const m = o.exports;
export {
  m as default
};
